import React from 'react'
import { Select, Space } from 'antd';
import styled from 'styled-components';
// import { IconImg } from '../../../StyledComponents/Header';
import { UserOutlined } from '@ant-design/icons';

const { Option } = Select;
function FilterSelect(props) {
  return (
    <SpaceItem wrap>
        <ItemSelect
            is_icon={props.is_icon}
            size="large"
            placeholder={props.placeholder ?props.placeholder : "Select"}
            style={{
                width: props.width? props.width : 230,
            }}
            onChange={props.handleChange}
            value={props.value}
            // options={props.options}
            height={props.height}
        >
            {props.options?.map((i,index)=> 
                <Option key={index} value={i.value}>{i.label? i.label : i.value}</Option>
            )} 
        </ItemSelect>
       
    </SpaceItem>
  )
}

export default FilterSelect

const SpaceItem = styled(Space)`
    position: relative;
`
const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: 8px !important;
        background-color: #F5F8FA !important;
        border: none !important;
        height: ${({height})=> height? height : 'unset'};
    }
    & .ant-select-selection-placeholder {
        color: #A1A5B7 !important;
        font-size: 14px;
        font-weight: 700;
        font-family: 'Roboto';
        font-style: normal;
    }
    & .ant-select-arrow {
        color: #7E8299 !important;
    }
    & .ant-select-selection-item {
        color: #202020;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
    }
    & .ant-select-item-option {
        font-size: 12px;
        font-family: 'Roboto';
        font-style: normal;
    }
`